import React from "react";
import {
    Badge,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    makeStyles,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CommentIcon from "@material-ui/icons/Comment";
import { Button } from "react-admin";
import {CommentSectionDialog} from "./DebtCollectionDetails";

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 10,
    },
    title: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(2),
    },
    titleLeft: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
}));

export function ShowComment({ record }: { record: any }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const commentsCount = record?.comments_count || record?.comments?.length || 0;

    const handleClickOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <IconButton size="small" onClick={handleClickOpen} title="Mostra commenti">
                <Badge
                    badgeContent={commentsCount}
                    color="primary"
                    invisible={!commentsCount}
                    max={99}
                >
                    <VisibilityIcon fontSize="small" />
                </Badge>
            </IconButton>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                classes={{ paper: classes.dialogPaper }}
                onClick={(event) => event.stopPropagation()}
            >
                <DialogTitle disableTypography>
                    <Box className={classes.title}>
                        <Box className={classes.titleLeft}>
                            <CommentIcon color="primary" />
                            <Box>
                                <Typography variant="h6">
                                    Commenti
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Fattura #{record?.sequence_number || record?.id}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </DialogTitle>

                <DialogContent dividers>
                    <CommentSectionDialog record={record} />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} label="Chiudi" />
                </DialogActions>
            </Dialog>
        </>
    );
}